import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import CreateUserContainer from 'containers/forms/users/CreateUserContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { AdminBreadcrumb, AdminBreadcrumbItem } from 'components/atoms/AdminBreadcrumb';
import PageTitle from 'hoc/PageTitle';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import { ADMINAREA_ACCESS } from 'constants/capabilities';

const CreateUserPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer
            title={(
                <AdminBreadcrumb>
                    <AdminBreadcrumbItem to="/admin/users">&lt; Users</AdminBreadcrumbItem>
                </AdminBreadcrumb>)}
            admin hideDatePicker />}>

        <CreateUserContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Create User', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS] }),
)(CreateUserPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/users/CreateUser.js